export class ConfirmationModalConfig {

  content: string;
  cancel: string;
  confirm: string;
  title: string;
  closed: (value: any) => void;

  constructor(
    content?: string,
    cancel?: string,
    confirm?: string,
    title?: string,
    closed?: (value: any) => void
  ) {
    this.content = content;
    this.cancel = cancel;
    this.confirm = confirm;
    this.title = title;
    this.closed = closed;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal-config.ts